import nanolog from '@turbowarp/nanolog';
nanolog.enable();

export default nanolog('storage');
